import { Injectable } from '@angular/core';
import { KeycloakService } from 'keycloak-angular';
import { KeycloakProfile } from 'keycloak-js';
import { Observable, from, of } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class KeycloakAuthService {
  token$: Observable<string>;
  constructor(private readonly keycloak: KeycloakService) {
    this.token$ = from(this.keycloak.getToken());
  }

  getToken(): Observable<string> {
    return this.token$;
  }

  
  isLoggedIn(): Observable<boolean> {
    return of(this.keycloak.isLoggedIn());
  }

  logout(): void {
    this.keycloak.logout();
  }

  getUserProfile(): Observable<KeycloakProfile> {
    return from(this.keycloak.loadUserProfile());
  }


  userRoles$ = of(
    this.keycloak.getKeycloakInstance()?.tokenParsed?.realm_access?.roles ?? []
  );
  


 
 
}
